import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeSelect", "tickIcon"]
  static values = { themeId: String }

  declare readonly themeSelectTarget: HTMLSelectElement
  declare readonly tickIconTarget: HTMLElement
  declare themeIdValue: string

  connect() {
    this.toggleTick()
  }

  themeIdValueChanged() {
    this.themeSelectTarget.value = this.themeIdValue
    this.toggleTick()
  }

  setThemeId(event: Event) {
    const target = event.currentTarget as HTMLSelectElement
    this.themeIdValue = target.value
    this.toggleTick()
  }

  toggleTick() {
    this.tickIconTarget.style.opacity = this.themeIdValue && this.themeIdValue !== "" ? "1" : "0"
  }
}
